import axios, { CancelToken } from 'axios';
import { IreqSolicitacoesUpgrade, IreqSolicitacoesUpgradeItem } from '../../../../pages/ListagemContrato/components/SolicitacoesDeUpgrade/interface';
import { urlHttpGov } from "../../../request/urls";
import { getToken } from "../../../token";

class SolicitacoesDeUpgradeService {

    async getQuantidadeNaoAtendida(signal?: CancelToken): Promise<{ quantidade_nao_atendidas?: number }> {

        const { data } = await axios.get(`${urlHttpGov}/solicitacao-upgrade/quantidade-nao-atendidas`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            cancelToken: signal
        });

        return data;
    }

    async getSolicitacaoUpgrade(signal?: CancelToken): Promise<IreqSolicitacoesUpgrade> {

        const { data } = await axios.get(`${urlHttpGov}/solicitacao-upgrade`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            cancelToken: signal
        });

        return data;
    }

    async getSolicitacaoUpgradeById(id: number | string, signal?: CancelToken): Promise<IreqSolicitacoesUpgradeItem> {

        const { data } = await axios.get(`${urlHttpGov}/solicitacao-upgrade/${id}`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            cancelToken: signal
        });

        return data;
    }

    async patchSolicitacaoUpgrade(
        id: number | string,
        dados: any,
        signal?: CancelToken
    ): Promise<IreqSolicitacoesUpgradeItem> {

        const { data } = await axios.patch(`${urlHttpGov}/solicitacao-upgrade/${id}`, dados, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            cancelToken: signal
        });

        return data;
    }


}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SolicitacoesDeUpgradeService();
